export const formatMoney = money => {
  return (money / 100.0).toFixed(2)
}



// WEBPACK FOOTER //
// ./src/utils/filters.js